/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <titleInfo @getHide="getHide" :title="title">
    </titleInfo>
    <div class="itemBodyMain">
      <div class="search">
        <div class="searchLeft">
          <div class="icon">
            <img src="../../../assets/home/icon_search.png" alt="">
          </div>
          <input type="text" placeholder="请输入关键字搜索"   v-model="filterText">
        </div>
        <div class="searchRight">搜索</div>
      </div>
      <div class="treebody scrollBar">
        <el-tree
          node-key="deptId"
          ref="tree"
          :data="organizationTree"
          :props="defaultProps"
          :default-expand-all="false"
          :default-expanded-keys="expandedKeys"
          :default-checked-keys="checkedKeys"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick">
          <template v-slot:default="{ node,data }">
<!--            <element-tree-line-->
<!--              :node="node"-->
<!--              :showLabelLine="true"-->
<!--              :indent="15"-->
<!--            >-->
<!--              &lt;!&ndash; 自定义label的slot &ndash;&gt;-->
<!--              <template v-slot:node-label>-->
<!--                <i-->
<!--                  :class="['fa', {'icon0' : treeLeaf(data)==1,'icon1': treeLeaf(data)==2,'icon2': treeLeaf(data)==3}]"-->
<!--                  class="mr10"></i>-->
<!--                <span style="font-size: 14px">{{ node.label }}</span>-->
<!--              </template>-->
<!--            </element-tree-line>-->
            <span style="font-size: 14px;margin-left: 10px;">{{ node.label }}</span>
          </template>
        </el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import Axios from "@/utils/Axios";
import Bus from "@/utils/bus.js";
export default {
  name: "index",
  components: {titleInfo},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      leavl: 0,
      filterText:"",
      organizationTree: [{
        name: '安徽省合肥市(10/20)',
        level: 1,
        childList: [
          {
            name: '中国科技大学(1/1)',
            level: 2,
            childList: [
              {
                name: '信息工程学院',
                level: 3,
              }
            ]
          },
          {
            name: '安徽大学(1/1)',
            level: 2,
            childList: [
              {
                name: '信息工程学院',
                level: 3,
              }
            ]
          },
          {
            name: '安徽农业大学(1/1)',
            level: 2,
            childList: [
              {
                name: '信息工程学院',
                level: 3,
              }
            ]
          },
        ]
      }],
      expandedKeys: [1],
      checkedKeys: [],
      defaultProps: {
        children: "children",
        label: "deptName",
      },
      // defaultProps: {
      //   children: 'childList',
      //   label: 'name',
      //   isLeaf: (data, node) => {
      //     if (node.level === 2) {
      //       return true
      //     }
      //   },
      // },
      list: [],
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  filters: {
    getType: function (next, typeData) {
      var name = ''
      typeData.forEach((type) => {
        if (type.id === next) {
          name = type.title
        }
      });
      return name
    }
  },
  mounted() {
    this.gettree()
  },
  methods: {

    gettree(){
      let that = this;
      let param = {};
      param.method="get";
      param.url="/dept/getDeptTree"

      param.params={
      }

      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){

          this.organizationTree = res.data;


        }else{

        }

      })
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    getHide() {
      this.$emit('getHide', 0)
    },
    handleNodeClick(data, node) {

      this.$emit('checkdata', data)
      Bus.$emit('changeid',data)
      // this.queryRealtimeList(data.deptId)
      //
      // this.id = data.id
      // this.leavl = data.level

    },
    treeLeaf(data) {

      return data.level;
    },
  }
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 44px);

    .search {
      margin: 12px;
      width: calc(100% - 24px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;

      .searchLeft {
        width: 100%;
        height: 28px;
        background: rgba(23, 66, 137, 0.5);
        border: 1px solid #2BB5FF;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
        box-sizing: border-box;

        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: nowrap;
          flex-direction: row;
          align-content: flex-start;
          width: 37px;

          img {
            width: 16px;
            height: 16px;
          }
        }

        input {
          width: 100%;
          height: 28px;
          background: none;
          font-size: 14px;
          font-family: PingFang;
          font-weight: 400;
          border: 0;
          outline: 0;
          color: #d0f6fc;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: nowrap;
          flex-direction: row;
          align-content: flex-start;
        }
      }

      .searchRight {
        width: 50px;
        height: 28px;
        background: #01A3FF;
        margin-left: 8px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
        font-size: 14px;
        font-family: PingFang;
        font-weight: 500;
        color: #FFFFFF;
      }
    }

    .treebody {
      height: calc(100% - 60px);
      width: 100%;
      position: relative;
      overflow-y: scroll;
    }

    .mr10 {
      margin-right: 10px;
    }

    ::v-deep {
      /* 设置树形最外层的背景颜色和字体颜色 */
      .element-tree-node-line-ver {
        border-left: 1px solid #3d7fd5;
      }

      .element-tree-node-line-hor {
        border-bottom: 1px solid #3d7fd5;

      }

      .el-tree {
        font-size: 14px;
        font-weight: 400;
        color: #CDF7FF;
        background: transparent;
        width: calc(100% - 40px);
        margin-left: 20px;
      }

      .is-leaf::before {
        display: none;
      }

      .el-tree > .el-tree-node > .element-tree-node-line-ver {
        display: none;
      }

      .element-tree-node-label-line {
        display: none;
      }

      .custom-tree-node {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;

        span {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: nowrap;
          flex-direction: row;
          align-content: flex-start;
        }
      }

      /* 设置三角形图标的颜色 */
      .el-tree-node__expand-icon {
        color: rgba(0, 172, 255, 1);
        width: 14px;
        height: 14px;
        background: url("../../../assets/home/icon_zhankai.png") center center no-repeat;
        background-size: 14px 14px;

        &::before {
          display: none;
        }
      }

      /* 设置三角形图标的颜色 */
      .el-tree-node__expand-icon.expanded {
        width: 14px;
        height: 14px;
        background: url("../../../assets/home/icon_shousuo.png") center center no-repeat;
        background-size: 14px 14px;
        transform: rotate(0deg);

        &::before {
          display: none;
        }
      }


      /* .el-tree-node__content:hover .el-tree-node__expand-icon.is-leaf {
        color: transparent;
      } */

      /* 树节点鼠标悬浮式改变背景色，字体颜色 */
      .el-tree-node__content:hover {
        background: none;
        color: rgba(0, 164, 255, 1);
      }

      .is-current .ellipsis {
        color: rgba(72, 231, 250, 1);
      }

      /* 改变节点高度 */
      .el-tree-node__content {
        height: 36px;
      }

      /* 节点前边的三角图标并不会被节点样式影响，需要单独修改 当前激活的颜色*/
      .el-tree-node:focus
      > .el-tree-node__content
      .el-tree-node__expand-icon {
        color: rgba(39, 114, 229, 1);
      }

      /* 改变被点击节点背景颜色，字体颜色 */
      .el-tree-node:focus > .el-tree-node__content {
        background: none;
        color: rgba(0, 164, 255, 1);
      }
    }
  }
}

.icon1 {
  background: url("../../../assets/home/icon_tree1.png") center center no-repeat;
  width: 20px;
  height: 25px;
  background-size: 15px 17px;
  display: inline-block;
}

.icon0 {
  background: url("../../../assets/home/icon_tree0.png") center center no-repeat;
  width: 20px;
  height: 25px;
  background-size: 16px 16px;
  display: inline-block;
}

.icon2 {
  background: url("../../../assets/home/icon_tree2.png") center center no-repeat;
  width: 20px;
  height: 25px;
  background-size: 16px 16px;
  display: inline-block;
}

</style>
